import { apiFetch, loginURL } from "./apiClient.js";

const StudentEmploymentType = 2;

let userPermissions = {};
let userId = null;
let userName = null;
let teamId = null;
let employmentType = null;

export function hasPermission(permission) {
    return userPermissions[permission] === true;
}

export async function auth() {
    const userData = await apiFetch("users/me", "GET", undefined, { silent: true });
    if (!userData) return false;

    if (userData === 404) {
        const { showNotRegisteredView } = await import("./views/infoView.js");
        showNotRegisteredView();
        return false;
    }

    if (userData === 403) {
        const { showInvalidSessionView } = await import("./views/infoView.js");
        showInvalidSessionView(loginURL);
        return false;
    }

    if (userData.id) userId = userData.id;
    if (userData.username) userName = userData.username;
    if (userData.teamId) teamId = userData.teamId;
    employmentType = userData.employmentType ?? null;
    if (userData.permissions && Array.isArray(userData.permissions)) {
        userPermissions = {}; // Reset before loading
        userData.permissions.forEach(p => userPermissions[p] = true);
    }

    return true;
}

export function getUserId() {
    return userId;
}

export function getUserName() {
    return userName;
}

export function getTeamId() {
    return teamId;
}

export function isWerkstudent() {
    return employmentType === StudentEmploymentType;
}